import { ICON_COLOR } from './tokens';
export const getIconColor = ({ alternateTheme, colorway, strength, }) => alternateTheme
    ? ICON_COLOR.ALTERNATE[colorway][strength]
    : ICON_COLOR.DEFAULT[colorway][strength];
